module.exports = __webpack_public_path__ + "static/media/intelligent.b7c1d40c.svg";